/* src/app/order/components/additional-questions/audit-dates/audit-dates.style.scss */
.audit-date-row:not(:last-child) {
  margin-bottom: 20px !important;
}
.audit-date-row svg-icon {
  position: relative;
  bottom: 6px;
  left: 5px;
}
.audit-date-row .date-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  display: block;
  text-transform: uppercase;
  margin-bottom: 10px;
  width: 100%;
}
.audit-date-row .date-label .optional-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #8C8C8C;
  font-weight: normal;
  text-transform: lowercase;
  padding: 0 0 0 15px;
}
.audit-date-row #desired-next-audit-date {
  width: 50%;
}
.audit-date-label-flex {
  display: flex;
  width: 100%;
}
.audit-date-label-flex .optional-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #8C8C8C;
  margin-left: auto !important;
  vertical-align: middle;
  text-align: right;
}
@media screen and (max-width: 767px) {
  .audit-date-label-flex .date-label {
    width: 100%;
  }
  .audit-date-label-flex .date-label .optional-label {
    padding: 0 0 0 7px;
  }
  .audit-date-row #desired-next-audit-date {
    width: 100%;
  }
}
/*# sourceMappingURL=audit-dates.style.css.map */
